import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CopyrightIcon from '@mui/icons-material/Copyright';
import { useHistory } from 'react-router-dom';

const labelStyle = {
  display: 'block',
  marginBottom: '4px',
  fontSize: '11px',
  fontWeight: '600',
  color: '#374151',
  textTransform: 'uppercase',
  letterSpacing: '0.3px'
};

const inputStyle = {
  width: '100%',
  padding: '6px 10px',
  border: '2px solid #e5e7eb',
  borderRadius: '6px',
  fontSize: '12px',
  transition: 'all 0.2s ease',
  outline: 'none'
};

const AppointmentCreate = () => {
  const history = useHistory();
  const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
  const hasCreateMasterPermission = permissions.includes('Create Master');
  const hasEditMasterPermission = permissions.includes('Edit Master');
  const hasDeleteMasterPermission = permissions.includes('Delete Master');
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();

      return;
    }
    // Token is not expired, fetch data
    fetchDoctors();
    fetchPatients();
    setLoading(true);
  }, [isAuthenticated, companyId, userId, token, logout]);


  // Get current date and time
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const [formData, setFormData] = useState({
    appointmentDate: getCurrentDate(),
    appointmentTime: getCurrentTime()
  });

  const [doctors, setDoctors] = useState([]);
  const [patients, setPatients] = useState([]);
  const [isPatientModalOpen, setIsPatientModalOpen] = useState(false);
  const [patientSearchQuery, setPatientSearchQuery] = useState('');

  const fetchDoctors = async () => {
    setLoading(true);
    fetchData('DoctorApi', `/${companyId}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setDoctors(response.response_data);

        }
        console.log(response);
      })
      .catch((error) => {
        console.error('Error fetching Doctor Details:', error);
        // Handle error, e.g., redirect to login if token is expired
        if (error.response && error.response.status === 401) {
          logout();
          // Redirect to login with the current location as a parameter
          history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
        }
      })
      .finally(() => {
        setLoading(false); // Hide loading screen
      });
  };

  const fetchPatients = async () => {
    setLoading(true);
    fetchData('PatientApi', `/${companyId}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setPatients(response.response_data);
        }
        console.log(response);
      })

      .catch((error) => {
        console.error('Error fetching Patient Details:', error);
        // Handle error, e.g., redirect to login if token is expired
        if (error.response && error.response.status === 401) {
          logout();
          // Redirect to login with the current location as a parameter
          history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
        }
      })
      .finally(() => {
        setLoading(false); // Hide loading screen
      });
  };


  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
      amount: Number(formData.amount),
      createdBy: 1,
      createdDate: new Date(),
    };

    const res = await fetch("/api/appointment/create", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const result = await res.json();
    alert(result.response);
  };

  return (
    <div style={{ padding: '6px', maxWidth: '100%' }}>
      <div style={{
        width: '100%',
        background: 'white',
        borderRadius: '8px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)',
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
        marginTop: '-30px'
      }}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)',
          padding: '10px 16px',
          borderBottom: '2px solid #1e40af'
        }}>
          <h2 style={{
            fontSize: '15px',
            fontWeight: '700',
            color: 'white',
            margin: 0,
            letterSpacing: '0.5px',
            textTransform: 'uppercase'
          }}>
            📅 Create Appointment
          </h2>
          <p style={{
            fontSize: '11px',
            color: 'rgba(255,255,255,0.9)',
            margin: '2px 0 0 0'
          }}>
            Schedule a new patient appointment
          </p>
        </div>

        {/* Form Content */}
        <div style={{ padding: '16px' }}>
          {/* Form Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            gap: '12px',
            marginBottom: '12px'
          }}>
            {/* Doctor */}
            <div>
              <label style={labelStyle}>
                Doctor <span style={{ color: '#dc2626' }}>*</span>
              </label>
              <select
                style={{ ...inputStyle, backgroundColor: 'white' }}
                value={formData.doctorId}
                onChange={(e) => handleChange("doctorId", e.target.value)}
                onFocus={(e) => e.target.style.borderColor = '#1e40af'}
                onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
              >
                <option value="">Select Doctor</option>
                {doctors.map((doctor) => (
                  <option key={doctor.Id} value={doctor.Id}>
                    {doctor.Name}
                  </option>
                ))}
              </select>
            </div>

            {/* Patient */}
            <div>
              <label style={labelStyle}>
                Patient <span style={{ color: '#dc2626' }}>*</span>
              </label>
              <input
                type="text"
                readOnly
                placeholder="Click to select patient"
                style={{ ...inputStyle, cursor: 'pointer', backgroundColor: 'white' }}
                value={formData.patientName || ''}
                onClick={() => setIsPatientModalOpen(true)}
                onFocus={(e) => e.target.style.borderColor = '#1e40af'}
                onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
              />
            </div>

            <div>
              <label style={labelStyle}>
                MRD No <span style={{ color: '#dc2626' }}>*</span>
              </label>
              <input
                type="text"
                readOnly
                placeholder="Click to select patient"
                style={{ ...inputStyle, cursor: 'pointer', backgroundColor: 'white' }}
                value={formData.patientMRD || ''}
                onClick={() => setIsPatientModalOpen(true)}
                onFocus={(e) => e.target.style.borderColor = '#1e40af'}
                onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
              />
            </div>

            <div>
              <label style={labelStyle}>
                Phone No <span style={{ color: '#dc2626' }}>*</span>
              </label>
              <input
                type="text"
                readOnly
                placeholder="Click to select patient"
                style={{ ...inputStyle, cursor: 'pointer', backgroundColor: 'white' }}
                value={formData.patientPhone || ''}
                onClick={() => setIsPatientModalOpen(true)}
                onFocus={(e) => e.target.style.borderColor = '#1e40af'}
                onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
              />
            </div>

            {/* Date */}
            <div>
              <label style={labelStyle}>
                Appointment Date <span style={{ color: '#dc2626' }}>*</span>
              </label>
              <input
                type="date"
                style={inputStyle}
                value={formData.appointmentDate}
                onChange={(e) => handleChange("appointmentDate", e.target.value)}
                onFocus={(e) => e.target.style.borderColor = '#1e40af'}
                onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
              />
            </div>

            {/* Time */}
            <div>
              <label style={labelStyle}>
                Appointment Time <span style={{ color: '#dc2626' }}>*</span>
              </label>
              <input
                type="time"
                style={inputStyle}
                value={formData.appointmentTime}
                onChange={(e) => handleChange("appointmentTime", e.target.value)}
                onFocus={(e) => e.target.style.borderColor = '#1e40af'}
                onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
              />
            </div>

            {/* Amount */}
            <div>
              <label style={labelStyle}>
                Amount <span style={{ color: '#dc2626' }}>*</span>
              </label>
              <input
                type="number"
                style={{ ...inputStyle, textAlign: 'right' }}
                value={formData.amount}
                onChange={(e) => handleChange("amount", e.target.value)}
                onFocus={(e) => e.target.style.borderColor = '#1e40af'}
                onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
              />
            </div>
          </div>

          {/* Remark - Full Width */}
          <div style={{ marginBottom: '12px' }}>
            <label style={labelStyle}>Remark</label>
            <textarea
              style={{
                ...inputStyle,
                minHeight: '60px',
                resize: 'vertical',
                fontFamily: 'inherit'
              }}
              value={formData.remark}
              onChange={(e) => handleChange("remark", e.target.value)}
              onFocus={(e) => e.target.style.borderColor = '#1e40af'}
              onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
            ></textarea>
          </div>

          {/* Checkboxes */}
          <div style={{
            display: 'flex',
            gap: '20px',
            flexWrap: 'wrap',
            padding: '12px',
            background: '#f9fafb',
            borderRadius: '6px',
            border: '1px solid #e5e7eb',
            marginBottom: '16px'
          }}>
            <label style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '500',
              color: '#374151'
            }}>
              <input
                type="checkbox"
                checked={formData.isConsultation}
                onChange={(e) => handleChange("isConsultation", e.target.checked)}
                style={{ width: '14px', height: '14px', cursor: 'pointer' }}
              />
              Consultation
            </label>

            <label style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '500',
              color: '#374151'
            }}>
              <input
                type="checkbox"
                checked={formData.isCompleted}
                onChange={(e) => handleChange("isCompleted", e.target.checked)}
                style={{ width: '14px', height: '14px', cursor: 'pointer' }}
              />
              Completed
            </label>

            <label style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '500',
              color: '#374151'
            }}>
              <input
                type="checkbox"
                checked={formData.isRescheduled}
                onChange={(e) => handleChange("isRescheduled", e.target.checked)}
                style={{ width: '14px', height: '14px', cursor: 'pointer' }}
              />
              Rescheduled
            </label>
          </div>

          {/* Submit Button */}
          <button
            onClick={handleSubmit}
            style={{
              width: '100%',
              padding: '10px 20px',
              background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '13px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              boxShadow: '0 2px 8px rgba(30, 64, 175, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 12px rgba(30, 64, 175, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 8px rgba(30, 64, 175, 0.3)';
            }}
          >
            💾 Save Appointment
          </button>
        </div>
      </div>

      {/* Patient Selection Modal */}
      {isPatientModalOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          padding: '20px'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '12px',
            width: '100%',
            maxWidth: '800px',
            maxHeight: '80vh',
            overflow: 'hidden',
            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)'
          }}>
            {/* Modal Header */}
            <div style={{
              background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)',
              padding: '16px 20px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '2px solid #1e40af',
              height: '25px'
            }}>
              <div>
                <p style={{
                  color: 'rgba(255,255,255,0.9)',
                  fontSize: '14px',
                  margin: '2px 0 0 0'
                }}>
                  Search and select a patient
                </p>
              </div>
              <button
                onClick={() => setIsPatientModalOpen(false)}
                style={{
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: 'none',
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px',
                  cursor: 'pointer',
                  color: 'white',
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
                onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
              >
                ×
              </button>
            </div>

            {/* Search Bar */}
            <div style={{ borderBottom: '1px solid #e5e7eb', height: '40px', padding: '3px' }}>
              <input
                type="text"
                placeholder="Search by MRD Number, Name, or Phone..."
                value={patientSearchQuery}
                onChange={(e) => setPatientSearchQuery(e.target.value)}
                style={{
                  width: '98%',
                  padding: '10px 16px',
                  border: '2px solid #e5e7eb',
                  borderRadius: '8px',
                  fontSize: '13px',
                  outline: 'none',
                  transition: 'all 0.2s ease',
                  height: '29px',
                  marginLeft: '10px'
                }}
                onFocus={(e) => e.target.style.borderColor = '#1e40af'}
                onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
              />
            </div>

            {/* Patient Table */}
            <div style={{
              maxHeight: 'calc(80vh - 200px)',
              overflowY: 'auto',
              padding: '0'
            }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                  <tr>
                    <th style={{
                      background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)',
                      color: 'white',
                      padding: '5px',
                      fontSize: '11px',
                      fontWeight: '700',
                      textAlign: 'left',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      borderRight: '1px solid rgba(255,255,255,0.1)'
                    }}>
                      MRD No
                    </th>
                    <th style={{
                      background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)',
                      color: 'white',
                      padding: '5px',
                      fontSize: '11px',
                      fontWeight: '700',
                      textAlign: 'left',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      borderRight: '1px solid rgba(255,255,255,0.1)'
                    }}>
                      Patient Name
                    </th>
                    <th style={{
                      background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)',
                      color: 'white',
                      padding: '5px',
                      fontSize: '11px',
                      fontWeight: '700',
                      textAlign: 'left',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}>
                      Phone No
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {patients
                    .filter(patient =>
                      patient.MRDNo?.toLowerCase().includes(patientSearchQuery.toLowerCase()) ||
                      patient.Name?.toLowerCase().includes(patientSearchQuery.toLowerCase()) ||
                      patient.ContactNumber1?.toLowerCase().includes(patientSearchQuery.toLowerCase())
                    )
                    .map((patient, index) => (
                      <tr
                        key={patient.Id}
                        onClick={() => {
                          setFormData(prev => ({
                            ...prev,
                            patientId: patient.Id,
                            patientName: patient.Name,
                            patientMRD: patient.MRDNo,
                            patientPhone: patient.ContactNumber1
                          }));
                          setIsPatientModalOpen(false);
                          setPatientSearchQuery('');
                        }}
                        style={{
                          cursor: 'pointer',
                          transition: 'background-color 0.15s ease',
                          backgroundColor: index % 2 === 0 ? 'white' : '#fafafa'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f9ff'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? 'white' : '#fafafa'}
                      >
                        <td style={{
                          padding: '10px',
                          fontSize: '12px',
                          color: '#1e40af',
                          fontWeight: '600',
                          borderBottom: '1px solid #e5e7eb',
                          borderRight: '1px solid #e5e7eb'
                        }}>
                          {patient.MRDNo || 'N/A'}
                        </td>
                        <td style={{
                          padding: '10px',
                          fontSize: '12px',
                          color: '#1f2937',
                          fontWeight: '500',
                          borderBottom: '1px solid #e5e7eb',
                          borderRight: '1px solid #e5e7eb'
                        }}>
                          {patient.Name}
                        </td>
                        <td style={{
                          padding: '10px',
                          fontSize: '12px',
                          color: '#1f2937',
                          fontWeight: '500',
                          borderBottom: '1px solid #e5e7eb'
                        }}>
                          {patient.ContactNumber1 || 'N/A'}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {patients.filter(patient =>
                patient.MRDNo?.toLowerCase().includes(patientSearchQuery.toLowerCase()) ||
                patient.Name?.toLowerCase().includes(patientSearchQuery.toLowerCase()) ||
                patient.ContactNumber1?.toLowerCase().includes(patientSearchQuery.toLowerCase())
              ).length === 0 && (
                  <div style={{
                    padding: '40px',
                    textAlign: 'center',
                    color: '#6b7280',
                    fontSize: '13px'
                  }}>
                    No patients found
                  </div>
                )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppointmentCreate;
